// extracted by mini-css-extract-plugin
export var closeButton = "_fu-2";
export var closeButtonIcon = "_fu-3";
export var lightboxContent = "_fu-1";
export var lightboxOverlay = "_fu-0";